<template>
  <div class="chat-group-creation">
    <v-card class="mt-6 mb-6">
      <v-card-title>Demande de nouveau canal de notification </v-card-title>
      <v-row>
        <v-col cols="6">
          <v-text-field
            class="ml-6"
            label="Nom du canal"
            v-model="channelName"
            outlined
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            class="mr-6"
            label="Utilisateurs"
            v-model="usersName"
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="auto">
          <v-btn color="primary" class="ml-6" @click="addCategory">
            Ajouter une catégorie
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn color="primary" @click="addKeyword">
            Ajouter un mot-clé
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-for="(param, index) in parameters"
        :key="index"
        class="mt-3 ml-6"
      >
        <template
          v-if="
            param.gtrends_category_id !== null &&
            param.gtrends_category_id !== undefined
          "
        >
          <v-col cols="12" md="5">
            <v-select
              v-model="param.gtrends_category_id"
              :items="categories"
              item-text="rmr_cat_name"
              item-value="id"
              label="Catégorie"
              outlined
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" md="5">
            <v-text-field
              v-model="param.sv"
              label="Volume de recherche"
              outlined
              hide-details
            ></v-text-field>
          </v-col>
        </template>

        <!-- Bloc mots-clés -->
        <template v-else-if="param.gtrends_keywords_id !== undefined">
          <v-col cols="12" md="5">
            <v-select
              v-model="param.gtrends_keywords_id"
              :items="keywords"
              item-text="name"
              item-value="id"
              label="Keywords"
              outlined
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" md="5">
            <v-text-field
              readonly
              label="Volume de recherches"
              outlined
              hide-details
              value="0 - Non Disponible"
            ></v-text-field>
          </v-col>
        </template>
      </v-row>
      <v-row v-if="parameters.length > 0" justify="center" class="mt-12 pb-6">
        <v-btn class="ml-6 mr-6 secondary" @click="saveChatGroupDemand"
          >Envoyer la demande</v-btn
        >
        <v-btn class="ml-6 mr-6 primary" @click="cancelParameters"
          >Annuler</v-btn
        >
      </v-row>
    </v-card>
  </div>
</template>
<script>
import useAxios from "@/hooks/useAxios";
export default {
  name: "ChatGroupCreation",
  components: {},
  data() {
    return {
      usersName: "",
      channelName: "",
      parameters: [],
      categories: [],
      keywords: [],
    };
  },
  setup() {
    const { axiosGet, axiosPost, isLoading } = useAxios();

    return {
      axiosGet,
      isLoading,
      axiosPost,
    };
  },
  async created() {
    await this.fetchCategories();
    await this.fetchKeywords();
  },
  methods: {
    async fetchKeywords() {
      const response = await this.axiosGet("/gtrends/keywords");
      this.keywords = response.data;
    },
    async fetchCategories() {
      const response = await this.axiosGet("/gtrends/categories");
      this.categories = response.data;
    },
    addCategory() {
      this.parameters.push({
        gtrends_category_id: "",
        sv: "",
      });
    },
    addKeyword() {
      this.parameters.push({
        gtrends_keywords_id: "",
        sv: "",
      });
    },
    cancelParameters() {
      this.parameters = [];
      this.$emit("close-dialog");
    },
    async saveChatGroupDemand() {
      console.log(this.channelName, this.parameters);
      const data = {
        channelName: this.channelName,
        usersName: this.usersName,
        parameters: this.parameters,
      };
      const response = await this.axiosPost(
        "/gtrends/create_chat_group_demand",
        data
      );
      console.log(data);
      this.$emit("saved");
      this.$emit("close-dialog");
      this.showSuccessMessage = true;
    },
  },
};
</script>
<style scoped>
.chat-group-creation {
  max-width: 1000px;
  margin: 0 auto;
}
</style>
